import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import i18n from '../../../Shared/Translation/i18n';
import DetailView from '../../../Shared/DetailView';
import useDetail from '../../../Shared/useDetail';
import InputCont from '../../../Shared/Form/InputCont';

import { ApiUrl } from '../../../project/Defines.js';
import { dispatchCustomEvent, EVENT_NAME } from '../../../project/utilities';

import { message } from 'antd';


/**
 * ...
 * @exports VersionDetails
 */
export default function ThercodimVersionDetails(props) {
    const { windowKey, data } = props;
    const [ linesCount, setLinesCount ] = useState();
    const { id } = useParams();
    
    const listUpdateEvent = EVENT_NAME.THERCODIM_VERSION_LIST_UPDATE;

    const { dataItem, setDataItem, updateData, hasChanges, closePopup, detailRef, onChangeData, validation } = useDetail({
        data: data || { ID: id !== "create" ? id : 0 },
        windowKey,
        updateUrl: ApiUrl.ThercodimVersionUpdate,
        dataLoadUrl: ApiUrl.ThercodimVersionLoad,
        //deleteUrl: ApiUrl.ThercodimVersionDelete,
        nameField: 'number',
        //backPage: AppPages.Version,
        listUpdateEvent,
        //detailUrl: Project.getPageUrl(AppPages.ThercodimVersionDetails),
        // changingValidation: true,
        validationFields: ["number", "comment"]
    });

    const updateSuccessCallback = useCallback((response) => {
        if (detailRef.current) {
            setDataItem(response);
            dispatchCustomEvent(listUpdateEvent, { action: 'update' });
            closePopup();
        }
    }, [setDataItem, detailRef, listUpdateEvent, closePopup]);

    useEffect(() => {
        if (dataItem) {
            const text = dataItem.comment;
            const lines = text.split("\n");
            const count = lines.length;
            setLinesCount(count);
        }
    }, [dataItem && dataItem.comment]);// eslint-disable-line react-hooks/exhaustive-deps

    const onMessage = useCallback(() => {
        if (linesCount > 29) {
            message.error('Comment can be long up to 30 lines.')
        }
    }, [linesCount]);

    return (<>
        {dataItem && <DetailView
            hasChanges={hasChanges}
            //backUrl={Project.getPageUrl(AppPages.Version)}
            //title={isNew ? i18n('text.version') : dataItem.version}
        >
            <view >
                    <div className="form_container">
                        <div className="section_group">
                            <div className="sections">
                                <InputCont 
                                    label='text.number' 
                                    inputProps={{ validation, name: 'number', maxLength: "20", value: dataItem.number, onChange: onChangeData }} 
                                />
                                <InputCont 
                                    label='text.comments' 
                                    inputProps={{ validation, type: 'textarea', name: 'comment', value: dataItem.comment, onChange: onChangeData }} 
                                />
                            </div>
                        </div>
                    </div>
                    <toolbar>
                        <wrap>
                            <action right=''>
                                <div 
                                    onClick={(e) => linesCount > 29 ? onMessage() : updateData(updateSuccessCallback)}
                                    className={hasChanges ? ' button primary' : 'button'}
                                    disabled={validation?.isValid ? false : true}>
                                <icon>save</icon>{i18n('text.save')}
                                </div>
                            {/* {dataItem.ID > 0 &&
                                    <div className='button' onClick={(e) => {
                                        onDetailDelete(dataItem, () => { navigate(Project.getPageUrl(AppPages.Version)) })
                                    }}>
                                    <icon>delete</icon>{i18n('text.delete')}
                                    </div>} */}
                            </action>
                        </wrap>
                    </toolbar>
            </view>
        </DetailView>}
    </>);
}





